var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"custom-class":"el-dialog-custom","center":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('span',[_c('el-image',{key:_vm.imgsrc,staticClass:"show-image",attrs:{"src":_vm.imgsrc,"lazy":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }